@if (!dismissed()) {
  <div
    class="iris-banner-root"
    [ngClass]="{
      'iris-banner--info': bannerType() === irisBannerType.INFO,
      'iris-banner--warning': bannerType() === irisBannerType.WARNING,
      'iris-banner--success': bannerType() === irisBannerType.SUCCESS,
      'iris-banner--disabled': bannerType() === irisBannerType.DISABLED
    }"
  >
    <div class="iris-banner-accent" aria-hidden="true"></div>
    <div class="iris-banner-surface">
      <div class="iris-banner-body">
        @if (hasIcon()) {
          <div class="iris-banner-icon-disc">
            <iris-icon
              [name]="iconName()!"
              [size]="iconSizes.MD"
              [colorToken]="iconColorToken()"
            ></iris-icon>
          </div>
        }

        <div class="iris-banner-text">
          @if (headerText()) {
            <h4 class="iris-banner-header">{{ headerText() }}</h4>
          }
          <ng-content select="[irisBannerCopy]"></ng-content>
        </div>

        <div class="iris-banner-cta">
          <ng-content select="[irisBannerActions]"></ng-content>
          @if (showDismiss()) {
            <iris-icon-button
              class="iris-banner-dismiss"
              [ariaLabel]="dismissAriaLabel()"
              icon="close"
              [iconSize]="iconSizes.SM"
              [type]="irisIconButtonTypes.TERTIARY"
              [typeAttribute]="buttonTypeAttribute.BUTTON"
              (click)="onDismiss()"
            ></iris-icon-button>
          }
        </div>
      </div>
    </div>
  </div>
}
